import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  signal,
  effect,
  inject,
  forwardRef
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { Subject, of } from 'rxjs';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-select-dropdown',
  imports: [CommonModule, NgSelectModule, FormsModule, MatIconModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './select-dropdown.component.html',
  styleUrl: './select-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDropdownComponent),
      multi: true
    }
  ]
})
export class SelectDropdownComponent<T = any> implements ControlValueAccessor{
  // @Input({ required: true }) items: T[] = [];
  // @Input() label = '';
  // @Input() placeholder = 'Select...';
  // @Input() displayKey: keyof T | string = 'label';
  // @Input() bindValue: keyof T | string | null = null;
  // @Input() multiple = false;
  // @Input() selected: T | T[] | null = null;


  // @Input({ required: true }) fetchItemsFn: (term: string) => any = () => of([]);
  @Input({ required: true }) items: T[] = [];
  @Input() label = '';
  @Input() clearable = true;
  @Input() placeholder = 'Select...';
  @Input() displayKey: keyof T | string = 'label';
  @Input() bindValue: keyof T | string | null = null;
  @Input() multiple = false;
  @Input() selected: T | T[]| null = null;
  @Input() icon = '';
  @Input() iconPosition = null;
  @Input() searchable = false;
  @Input() class: string;

  @Output() selectionChanged = new EventEmitter<T | T[]>();
  @Output() selectionCleared = new EventEmitter<T | T[]>();

  searchInput$ = new Subject<string>();
  // items: T[] = [];
  loading = false;
  value: any;

  constructor() {
    // this.setupSearchEffect();
  }

  private onChangeFn: (value: any) => void = () => {};
  private onTouchedFn: () => void = () => {};

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // handle disable state if needed
  }


  onSearch(term: string): void {
    if (term.length < 3) {return;}
    this.searchInput$.next(term);
  }

  onChange(selection: T): void {
    this.selected = selection;
    let emittedValue: any = selection;
  
    if (this.bindValue && selection && typeof selection === 'object') {
      if (!Array.isArray(selection)) {
      //   emittedValue = selection.map(item => item[this.bindValue as keyof T]);
      // } else {
        emittedValue = selection[this.bindValue as keyof T];
      }
    }
    this.onChangeFn(emittedValue);
    this.onTouchedFn();
    this.selectionChanged.emit(emittedValue);
  }

  writeValue(value: T | T[] | null): void {
    if (!value || !this.items?.length) {
      this.selected = null;
      this.value = null;
      return;
    }
  
    if (this.bindValue) {
      if (Array.isArray(value)) {
        const selectedItems = value.map(val => {
          const id = typeof val === 'object' ? val[this.bindValue as keyof T] : val;
          return this.items.find(item => item[this.bindValue as keyof T] === id);
        }).filter(Boolean) as T[];
  
        this.selected = selectedItems;
      } else {
        const id = typeof value === 'object' ? value[this.bindValue as keyof T] : value;
        const found = this.items.find(item => item[this.bindValue as keyof T] === id);
        this.selected = found ?? null;
      }
    } else {
      this.selected = value;
    }
  
    this.value = this.selected;
  }


  compareByValue = (item1: any, item2: any) => item1 === item2;

  get bindLabel(): keyof T | string {
    return this.displayKey || 'label';
  }

  // private setupSearchEffect(): void {
  //   this.searchInput$
  //     .pipe(
  //       debounceTime(300),
  //       distinctUntilChanged(),
  //       tap(() => (this.loading = true)),
  //       switchMap((term: string) => this.fetchItemsFn(term).pipe(tap(() => (this.loading = false))))
  //     )
  //     .subscribe({
  //       next: (results: T[]) => (this.items = results),
  //       error: () => (this.loading = false)
  //     });
  // }
}
